import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ListaLLModal from '../atendimento/ListaLLModal';
import { resumoLista } from '../atendimento/listaLL';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Lista LL na linha da LL do Dashboard, ao lado do check (Adnéia, 29/10/2026): vermelho enquanto a
// lista do dia não foi importada, verde depois. O clique abre a lista (e a importação).
export default function BotaoListaLL({ getAuthHeader, user }) {
  const [lista, setLista] = useState(null);
  const [aberta, setAberta] = useState(false);
  const authRef = useRef(getAuthHeader);
  authRef.current = getAuthHeader;

  const carregar = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/lista-ll`, { headers: authRef.current() });
      setLista(data);
    } catch {
      setLista(null);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const importada = !!lista?.importada;
  const r = resumoLista(lista?.tickets);
  const titulo = !lista
    ? 'Lista LL: abrir'
    : importada
      ? `Lista LL de hoje importada por ${lista.importado_por || '?'} às ${lista.importado_em_brt || '?'}: `
        + `${r.total} ticket(s), ${r.conferidos} conferido(s). Clique para abrir.`
      : 'Lista LL de hoje ainda não importada: baixe o arquivo dos tickets no portal da LL e importe aqui.';

  return (
    <>
      <button type="button" onClick={(e) => { e.stopPropagation(); setAberta(true); }} title={titulo}
        data-testid="btn-lista-ll"
        className={`flex-shrink-0 text-[11px] font-bold px-1.5 py-0.5 rounded border whitespace-nowrap ${importada
          ? 'bg-emerald-100 text-emerald-700 border-emerald-300 hover:bg-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800'
          : 'bg-red-100 text-red-700 border-red-300 hover:bg-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800'}`}>
        {importada ? `Lista LL ✓ ${r.conferidos}/${r.total}` : 'Lista LL: importar'}
      </button>
      {aberta && (
        <ListaLLModal getAuthHeader={getAuthHeader} user={user}
          onClose={() => { setAberta(false); carregar(); }} />
      )}
    </>
  );
}
